import { Component, OnInit, ViewChild, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { SecurityService } from 'src/app/shared/services/security.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { v4 as uuidv4 } from 'uuid';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { QueryResult } from 'src/app/shared/object/queryResult.model';
import { ClienteProveedorService } from 'src/app/services/cliente-proveedor.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { ToastService } from 'ng-uikit-pro-standard';

enum DISPLAY_TYPE {
  RUT_SUCURSAL = 'RUT_SUCURSAL',
  ONLY_RUT = 'ONLY_RUT'
}

@Component({
  selector: 'app-modal-show-clientes',
  templateUrl: './modal-show-clientes.component.html',
  styleUrls: ['./modal-show-clientes.component.scss'],
  providers: [SecurityService],
})
export class ModalShowClientesComponent implements OnInit {

  @Input() mode: 'ONLY_RUT' | 'RUT_SUCURSAL' = 'ONLY_RUT'

  // Modales
  @ViewChild('seleccionarCliente', { static: true })
  seleccionarClienteModal: ModalDirective;

  // data & temp
  listaClientes: Array<any> = []

  // Utils
  private log: any

  constructor(
    private clog: ConsoleService,
  ) {
    this.log = this.clog.log('MODAL-SHOW-CLIENTES')
  }

  ngOnInit() {
  }

  trackByClienteRut(index: number, item: any) {
    return item && item.rut != null ? item.rut : index;
  }

  show(data: Array<any>) {
    this.log(data)
    this.listaClientes = data
    this.seleccionarClienteModal.show();
  }

  hide() {
    this.seleccionarClienteModal.hide();
  }

}
